<template>
  <div>
    <div class="title_all" style="margin-bottom: 0">
      <div class="title_left">{{ title }}</div>
      <div class="title_more2"><a href="/">Home</a>>{{ title }}</div>
      <div class="clearfix"></div>
    </div>

    <div class="side_container">
      <div class="rightfloat hidden-sm-and-down">
        <span class="leftfloat">
          <el-input
            placeholder="Title"
            size="small"
            v-model="keyWords"
            @keyup.enter="search"
          ></el-input>
        </span>
        <span class="leftfloat ml1">
          <el-button type="primary" size="small" @click="search" :disa="disa"
            >Search</el-button
          >
        </span>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <div class="tgxz ten">
        <div class="notice">
          <ul>
            <li v-for="(item, i) in list" :key="i">
              <span class="rightfloat hidden-sm-and-down highgray"
                >[{{ item.DateCreate }}]</span
              >
              <a
                v-if="!isgzh"
                href
                v-html="item.Title"
                @click="NewsDetails($event, item, item.Id)"
              ></a>
              <a
                v-else
                href
                v-html="item.Title"
                @click="NewsDetailsa($event, item, item.Id)"
              ></a>
              <i
                class="icon iconfont highred"
                style="font-size: 22px"
                v-if="currentPage == 1 && i == 0"
                >&#xe62a;</i
              >
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
      <commonpage
        v-if="!isgzh"
        :count="count"
        @pageSize="pageSize"
        @pageindex="index"
        :index="paramas"
      ></commonpage>
    </div>
  </div>
</template>

<script>
import commonpage from '../components/CommonPage'
export default {
  data() {
    return {
      list: [],
      title: '',
      keyWords: '',
      newList: [],
      count: 0,
      currentPage: 1,
      disa: false,
      Authorgardon: [],
      ColumnId: 0,
      paramas: {
        ColumnId: 0,
        PageSize: 0,
        PageIndex: 0,
        Key: '',
      },
    }
  },
  components: {
    commonpage,
  },
  props: ['isgzh'],
  mounted() {
    if (this.$route.query.ColumnId) {
      this.ColumnId = this.$route.query.ColumnId
      this._getActor(this.ColumnId, 10, 1, this.keyWords)
    }
  },
  watch: {
    $route: {
      handler() {
        this.ColumnId = parseInt(this.$route.query.ColumnId) //处理两个ColumnId 之间切换页面不切换的问题
        this._getActor(this.ColumnId, 10, 1, this.keyWords)
      },
      deep: true,
    },
  },
  methods: {
    _getActor(ColumnId, pageSize, index, keyWords) {
      this.paramas = {
        ColumnId: ColumnId,
        PageSize: pageSize,
        PageIndex: index,
        Key: keyWords,
      }
      this.$store
        .dispatch('_getActor', this.paramas)
        .then((res) => {
          if (res.data.IsSuccess) {
            document.title = res.data.Message
            this.title = res.data.Message
            this.list = res.data.Data
            this.newList = res.data.Data
            this.title = res.data.Message
            this.count = res.data.ItemCount
            for (var a = [], n = 0, i = this.list.length; n < i; n += pageSize)
              a.push(this.list.slice(n, n + pageSize))

            //存储分割好的数组
            for (var k = 0; k < a.length; k++) {
              if (this.currentPage == k + 1) {
                this.newList = a[k]
              }
            }
          }
        })
        .then(() => {
          this.newList = []
          if (this.list.length == 0) {
            this.isShowTip = true
          }
          this.list.map((item) => {})
        })
        .catch((err) => {
          console.log(err)
        })
    },
    pageSize(val) {
      this.paramas.PageSize = val
      this._getActor(
        this.paramas.ColumnId,
        val,
        this.paramas.PageIndex,
        this.keyWords
      )
    },
    index(val) {
      this.paramas.PageIndex = val
      this._getActor(
        this.paramas.ColumnId,
        this.paramas.PageSize,
        val,
        this.keyWords
      )
    },
    //搜索关键字
    brightkeyWords(val) {
      let keyWords = this.keyWords
      if (val.indexOf(keyWords) !== -1) {
        return val.replace(keyWords, `<span color='red'>${keyWords}</span>`)
      } else {
        return val
      }
    },
    search() {
      this.disa = true
      this._getActor(this.paramas.ColumnId, 10, 1, this.keyWords)
    },
    NewsDetails(e, x, id) {
      e.preventDefault()
      if (x.DataType == 'Text' || x.DataType == '文字') {
        let routeUrl = this.$router.resolve({
           path: "/NewsDetails",
          query: { ItemId: id },
        })
        window.open(routeUrl.href, '_blank')
      } else if (x.DataType == 'File' || x.DataType == '文件') {
        if (x.FileGUID == '') {
          alert('下载失败,未发现文件')
          return
        }
        var aa = x.FileGUID
        var ac = x.Title
        this.OpenGUIDFile(aa)
      } else if (x.DataType == 'Link' || x.DataType == '链接') {
        window.open(x.Url, '_blank')
      }
    },
    NewsDetailsa(e, x, id) {
      e.preventDefault()
      if (x.DataType == 'Text' || x.DataType == '文字') {
        let routeUrl = this.$router.resolve({
           path: "/gzhNewsDetails",
          query: { ItemId: id },
        })
        window.open(routeUrl.href, '_blank')
      } else if (x.DataType == 'File' || x.DataType == '文件') {
        if (x.FileGUID == '') {
          alert('下载失败,未发现文件')
          return
        }
        var aa = x.FileGUID
        var ac = x.Title
        this.OpenGUIDFile(aa)
      } else if (x.DataType == 'Link' || x.DataType == '链接') {
        window.open(x.Url, '_blank')
      }
    },
    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch('_OpenGUIDFile', {
          FileGUID: FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1)
          } else {
            this.$error(res.data.Message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
